export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/AC campaign.38ec0c3a.gif","height":480,"width":819,"blurWidth":0,"blurHeight":0};